import styles from './FJInput.module.less';
import classNames from 'classnames';
import { useEffect, useRef } from 'react';

const FJInput = props => {
    const { placeholder, style, className, onChange, value, maxLength } = props;
    const inputRef = useRef(null);
    useEffect(() => {
        inputRef.current.value = value;
    }, [value]);

    const _onChange = e => {
        onChange(e.target.value);
    };

    return (
        <div className={classNames(styles.box, className)} style={style}>
            <input
                ref={inputRef}
                className={styles.input}
                type='text'
                placeholder={placeholder}
                onChange={_onChange}
                maxLength={maxLength}
            />
        </div>
    );
};

export default FJInput;
